"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResponsiveGridItem = useResponsiveGridItem;
const utils_1 = require("./utils");
function useResponsiveGridItem({ colSpan = 1 }) {
    return { gridItemProps: { [utils_1.gridItemDataAttribute]: colSpan } };
}
